// src/components/common/CancelledPatientCard.jsx
import React from "react"
import { convertMinutesTo12HHMM } from "../../utils/generalUtils"

const CancelledPatientCard = ({ patient, nurseName, chairName }) => {
	// Format the scheduledStartTime using the utility function if it's a number
	const formattedTime =
		typeof patient.scheduledStartTime === "number"
			? convertMinutesTo12HHMM(patient.scheduledStartTime)
			: patient.scheduledStartTime

	return (
		<div className="p-3 bg-white shadow-sm rounded-lg mb-2">
			<div className="flex items-center">
				<div
					className="w-[200px] font-semibold text-gray-900 truncate"
					title={patient.patientName}
				>
					{patient.patientName}
				</div>
				<div
					className="w-[160px] text-sm text-gray-700 truncate"
					title={nurseName || patient.assignedNurse}
				>
					{nurseName || patient.assignedNurse}
				</div>
				<div
					className="w-[130px] text-sm text-gray-700 truncate"
					title={patient.infusionType}
				>
					{patient.infusionType}
				</div>
				<div className="w-[100px] text-sm text-gray-700 truncate" title={formattedTime}>
					{formattedTime}
				</div>
				<div
					className="w-[100px] text-sm text-gray-700 truncate"
					title={chairName || patient.assignedChair}
				>
					{chairName || patient.assignedChair}
				</div>
			</div>
		</div>
	)
}

export default CancelledPatientCard
